export const promptVersionOptions = [
  { value: 'default', label: 'Default' },

  { value: 'v.spin.t', label: 'v.spin.t' },

  { value: 'v.spin', label: 'v.spin' },
]
